export interface PlayerAccessRights {
  mouse?: boolean;
  keyboard?: boolean;
  touch?: boolean;
  gamepad?: boolean;
}

let logs = [] as string[];
let event = null as Event | null;
let access: PlayerAccessRights = {
  mouse: false,
  keyboard: false,
  touch: false,
  gamepad: false,
};

const subs = {
  logs: [] as ((events: string[]) => void)[],
  event: [] as ((event: Event) => void)[],
  access: [] as ((access: PlayerAccessRights) => void)[],
};

const emitEventChange = () => {
  if (!event) return;
  for (const s of subs.event) {
    s(event);
  }
};

const emitLogsChange = () => {
  for (const s of subs.logs) {
    s(logs);
  }
};

const emitAccessChange = () => {
  for (const s of subs.access) {
    s(access);
  }
};

export const captureStore = {
  addEvent(e: Event) {
    logs = [e.type, ...logs];
    if (logs.length > 10) {
      logs.pop();
    }
    event = e;
    emitLogsChange();
    emitEventChange();
  },
  updateAccess(newAccess: PlayerAccessRights) {
    if (
      access.mouse !== newAccess.mouse ||
      access.keyboard !== newAccess.keyboard ||
      access.touch !== newAccess.touch ||
      access.gamepad !== newAccess.gamepad
    ) {
      access = { ...newAccess };
      emitAccessChange();
    }
  },
  subscribeEvent(callback: (event: Event) => void) {
    subs.event = [...subs.event, callback];
    return () => {
      subs.event = subs.event.filter((s) => s !== callback);
    };
  },
  subscribeLogs(callback: (events: string[]) => void) {
    subs.logs = [...subs.logs, callback];
    return () => {
      subs.logs = subs.logs.filter((s) => s !== callback);
    };
  },
  subscribeAccess(callback: (access: PlayerAccessRights) => void) {
    subs.access = [...subs.access, callback];
    return () => {
      subs.access = subs.access.filter((s) => s !== callback);
    };
  },
  getEvent() {
    return event;
  },
  getLogs() {
    return logs;
  },
  getAccess() {
    return access;
  },
};
